import transFunction from '../trans-function';
import variableRecursive from '../variable-recursive';

const arrayJoin = (target, data) => transFunction(target, 'array_join', (match, regexClear) => {
  const args = match.replace(regexClear, '').split(',');

  const attrs = variableRecursive(args[0], data);
  const template = args[1].replace(RegExp('\'', 'g'), '');
  let returnTemplate = '';

  attrs.forEach((attr) => {
    returnTemplate += template;
    Object.keys(attr).forEach((key) => {
      returnTemplate = returnTemplate.replace(RegExp(`\\$${key}`, 'g'), attr[key]);
    });
  });

  return returnTemplate;
});

export default arrayJoin;
